<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>{{ grocer.title }}</strong>
                </CCardHeader>
                <CCardBody>
                    <GrocerTabLinks />

                    <IntegrationNotice
                        :has-integration="!!grocer.alias"
                        :is-business-admin="!adminOnly"
                    />

                    <CRow class="pl-3 pb-3" />

                    <CRow class="pl-3 pb-3" />
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Название</CCol>
                        <CCol sm="9" class="col-form-label">{{ grocer.title }}</CCol>
                    </CRow>
                    <CRow
                        v-if="grocer.why_is_it_off" 
                        form
                        class="form-group"
                        style="color: red; font-weight: 600">
                        <CCol sm="3" class="col-form-label">Последнее отключение:</CCol>
                        <CCol sm="9" class="col-form-label">
                            Причина: {{ grocer.why_is_it_off }}
                            <br /> Кто отключил: {{ grocer.who_turned_off }}
                            <br /> Дата отключения: {{ grocer.shutdown_date }}
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Код</CCol>
                        <CCol sm="9" class="col-form-label">{{ grocer.code }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Алкоголь</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CBadge :color="getBadge(grocer.is_alcohol)">
                                &nbsp;{{ grocer.is_alcohol ? "Да" : "Нет" }}&nbsp;
                            </CBadge>
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Программа лояльности</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CBadge :color="getBadge(grocer.loyalty)">
                                &nbsp;{{ grocer.loyalty ? "Да" : "Нет" }}&nbsp;
                            </CBadge>
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Юр. лицо</CCol>
                        <CCol sm="9" class="col-form-label">{{ grocer.legal_entity }}</CCol>
                    </CRow>
                    <CRow
                        v-if="grocer.partner"
                        form
                        class="form-group">
                        <CCol sm="3" class="col-form-label">Партнер</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CLink v-if="adminOnly" :to="`/partners/${grocer.partner.id}`">{{ grocer.partner.title }}</CLink>
                            <template v-else>{{ grocer.partner.title }}</template>
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Башня</CCol>
                        <CCol sm="9" class="col-form-label">{{ grocer.towerObj ? grocer.towerObj.name : '' }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Зона</CCol>
                        <CCol sm="9" class="col-form-label">{{ grocer.towerObj && grocer.towerObj.zone ? grocer.towerObj.zone.name : '' }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Короткое название</CCol>
                        <CCol sm="9" class="col-form-label">{{ grocer.short_title }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Краткое описание</CCol>
                        <CCol
                            sm="9"
                            class="col-form-label"
                            v-html="grocer.description" />
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Картинка</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CImg
                                :src="pictureUrl"
                                class="m2"
                                width="300" />
                        </CCol>
                    </CRow>

                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Картинка для поиска</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CImg
                                :src="squarePictureUrl"
                                class="m2"
                                width="150" />
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Картинка для доставки</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CImg
                                :src="deliveryPictureUrl"
                                class="m2"
                                width="300" />
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Картинка для десктопа (внутри сервиса)</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CImg
                                :src="desktopPictureUrl"
                                class="m2"
                                width="300" />
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Картинка для десктопа (список)</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CImg
                                :src="desktopPictureUrlInList"
                                class="m2"
                                width="300" />
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Картинка для популярного</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CImg
                                :src="popularPictureUrl"
                                class="m2"
                                width="300" />
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Адрес для доставки</CCol>
                        <CCol sm="9" class="col-form-label">{{ grocer.address }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Открывается в</CCol>
                        <CCol sm="9" class="col-form-label">{{ grocer.open_at }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Закрывается в</CCol>
                        <CCol sm="9" class="col-form-label">{{ grocer.close_at }}</CCol>
                    </CRow>

                    <!-- <Schedule :schedule="grocer.schedule" /> DELETE -->

                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Скрывать когда закрыт</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CBadge :color="getBadge(grocer.hide)">
                                &nbsp;{{ grocer.hide ? 'Да' : 'Нет' }}&nbsp;
                            </CBadge>
                        </CCol>
                    </CRow>
                    <WorkingHours 
                        :working-hours="workingHours"
                        :service-type="'grocer'"
                    />

                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Минимальный заказ</CCol>
                        <CCol sm="9" class="col-form-label">{{ grocer.min_price ? grocer.min_price : "" }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Минимальная сумма для самовывоза</CCol>
                        <CCol sm="9" class="col-form-label">{{ grocer.min_price_pickup ? grocer.min_price_pickup : "" }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Ограничение по весу</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CBadge :color="getBadge(grocer.weight_limit)">
                                &nbsp;{{ grocer.weight_limit ? "Есть" : "Нет" }}&nbsp;
                            </CBadge>
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Телефон</CCol>
                        <CCol sm="9" class="col-form-label">{{ grocer.phone }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Время доставки (часы:минуты)</CCol>
                        <CCol sm="9" class="col-form-label">{{
                            `${appendNull(grocer.delivery_time_hour)}:${appendNull(grocer.delivery_time)}`
                        }}</CCol>
                    </CRow>
                    <CRow
                        v-if="grocer.max_delivery_time_hour || grocer.max_delivery_time"
                        form
                        class="form-group">
                        <CCol sm="3" class="col-form-label">Максимальное время доставки (часы:минуты)</CCol>
                        <CCol sm="9" class="col-form-label">{{
                            `${appendNull(grocer.max_delivery_time_hour)}:${appendNull(grocer.max_delivery_time)}`
                        }}</CCol>
                    </CRow>

                    <TimeSlots :time-slots="timeSlots" />

                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Алиас</CCol>
                        <CCol sm="9" class="col-form-label">{{ grocer.alias }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Лейбл</CCol>
                        <CCol sm="9" class="col-form-label">{{ labelType(grocer.service_label) }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Страница категорий</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CBadge :color="getBadge(grocer.categories_page)">
                                &nbsp;{{ grocer.categories_page ? "Да" : "Нет" }}&nbsp;
                            </CBadge>
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Показывать на главной</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CBadge :color="getBadge(grocer.show_main_page)">
                                &nbsp;{{ grocer.show_main_page ? 'Да' : 'Нет' }}&nbsp;
                            </CBadge>
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Показывать статус постоплаты</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CBadge :color="getBadge(grocer.status_postpay)">
                                &nbsp;{{ grocer.status_postpay ? "Да" : "Нет" }}&nbsp;
                            </CBadge>
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Убрать применение промокода</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CBadge :color="getBadge(grocer.hide_promocode)">
                                &nbsp;{{ grocer.hide_promocode ? "Да" : "Нет" }}&nbsp;
                            </CBadge>
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Отключить применение тарифов по зонам</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CBadge :color="getBadge(grocer.delivery_zone_disabled)">
                                &nbsp;{{ grocer.delivery_zone_disabled ? "Да" : "Нет" }}&nbsp;
                            </CBadge>
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Активен</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CBadge :color="getBadge(grocer.enabled)">
                                &nbsp;{{ grocer.enabled ? "Да" : "Нет" }}&nbsp;
                            </CBadge>
                        </CCol>
                    </CRow>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="goBack">Назад</CButton>
                    <CButton
                        color="danger"
                        class="mr-3"
                        @click="stopModal = true">Стоп</CButton>
                </CCardFooter>
            </CCard>
        </CCol>

        <StopServiceModal
            :id="$route.params.id"
            :open="stopModal"
            :type="BUSINESS_TYPE.GROCER"
            @stop-modal-close="stopModal = false"
            @stop-modal-update="setSchedule"
        />
    </CRow>
</template>

<script>
    import Vue from 'vue';

    import GrocerTabLinks from '@/components/grocers/GrocerTabLinks';
    import IntegrationNotice from '@/components/IntegrationNotice';
    // import Schedule from '@/components/Schedule';
    import TimeSlots from '@/components/TimeSlots';
    import WorkingHours from '@/components/WorkingHours';
    import StopServiceModal from '@/components/StopServiceModal';
    import { BUSINESS_TYPE } from '@/utils/order';
    import { BUSINESS_LABEL } from '@/utils/servicesLabel';

    export default {

        name: 'Grocer',
        components: {
            GrocerTabLinks,
            IntegrationNotice,
            // Schedule,
            TimeSlots,
            StopServiceModal,
            WorkingHours
        },

        beforeRouteEnter(to, from, next) {
            next(vm => {});
        },

        data() {
            return {
                timeSlots: undefined,
                workingHours: [],
                grocer: {
                    service_label: '',
                    schedule: [],
                    code: '',
                    title: '',
                    short_title: '',
                    description: '',
                    picture: '',
                    square_picture: '',
                    desktop_picture: '',
                    desktop_picture_list: '',
                    popular_picture: '',
                    towerObj: {
                        name: '',
                    },
                    open_at: '',
                    close_at: '',
                    extended_schedule: false,
                    categories_page: false,
                    status_postpay: false,
                    hide_promocode: false,
                    show_main_page: false,
                    min_price: 0,
                    phone: '',
                    delivery_time: 0,
                    delivery_time_hour: 0,
                    enabled: true,
                    is_alcohol: false,
                    loyalty: false,
                    position: 0,
                    data_url: '',
                },
                stopModal: false,
                BUSINESS_TYPE,
                adminOnly: false
            };
        },

        computed: {
            pictureUrl() {
                if (this.grocer.picture) {
                    return (
                        process.env.VUE_APP_STATIC_BASE_URL +
                        '/' +
                        this.grocer.picture
                    );
                } else {
                    return '';
                }
            },
            squarePictureUrl() {
                if(this.grocer.square_picture) {
                    return process.env.VUE_APP_STATIC_BASE_URL + '/' + this.grocer.square_picture;
                } else {
                    return '';
                }
            },
            desktopPictureUrl() {
                if(this.grocer.desktop_picture) {
                    return process.env.VUE_APP_STATIC_BASE_URL + '/' + this.grocer.desktop_picture;
                } else {
                    return '';
                }
            },
            desktopPictureUrlInList() {
                if(this.grocer.desktop_picture_list) {
                    return process.env.VUE_APP_STATIC_BASE_URL + '/' + this.grocer.desktop_picture_list;
                } else {
                    return '';
                }
            },
            popularPictureUrl() {
                if(this.grocer.popular_picture) {
                    return process.env.VUE_APP_STATIC_BASE_URL + '/' + this.grocer.popular_picture;
                } else {
                    return '';
                }
            },
            deliveryPictureUrl() {
                if(this.grocer.delivery_picture) {
                    return process.env.VUE_APP_STATIC_BASE_URL + '/' + this.grocer.delivery_picture;
                } else {
                    return '';
                }
            }
        },

        mounted() {
            this.adminOnly = !JSON.parse(localStorage.getItem('settings')).is_business_admin;
            const id = this.$route.params.id;
            Vue.axios
                .get('/grocers/' + id)
                .then(resp => {
                    this.grocer = resp.data;
                    if (resp.data.timeSlots.length != 0) {
                        this.timeSlots = resp.data.timeSlots;
                    }
                    if (resp.data.workingHours.length != 0) {
                        this.workingHours = resp.data.workingHours;
                    }
                })
                .catch(err => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
        },
        methods: {
            labelType (label) {
                const labels = [];
                labels.push({ value: BUSINESS_LABEL.IS_NEW, label: 'Новый сервис' });
                labels.push({ value: BUSINESS_LABEL.VEGAN, label: 'Веган' });
                labels.push({ value: BUSINESS_LABEL.VERIFIED_MIRCITY, label: 'Првоерено МИРСИТИ' });

                for (const type of labels) {
                    if(label === type.value){
                        return type.label;
                    }
                }
                return '';
            },
            appendNull(number) {
                if (!number) {
                    return '00';
                }
                return number < 10 ? `0${number}` : number;
            },
            goBack() {
                this.$router.push({ path: '/grocers' });
            },
            getBadge(status) {
                return status ? 'success' : 'secondary';
            },
            setSchedule(schedule) {
                if (schedule) {
                    this.grocer.schedule = schedule;
                }
            }
        },
    };
</script>
<style lang="scss" scoped>

</style>
